// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-button[data-v-5e8a5c3b]:hover {\n  background-color: white;\n  color: var(--carbon-500);\n}\n.add-button[data-v-5e8a5c3b]:active {\n  color: white;\n  background-color: var(--carbon-500);\n}", ""]);
// Exports
module.exports = exports;
